import * as React from 'react';

export type ScrollContainerTarget =
  | React.RefObject<HTMLDivElement | null>
  | HTMLDivElement
  | null;

const isRefObject = (
  target: ScrollContainerTarget
): target is React.RefObject<HTMLDivElement | null> =>
  target !== null && typeof target === 'object' && 'current' in target;

export const resolveScrollElement = (
  target: ScrollContainerTarget
): HTMLDivElement | null => (isRefObject(target) ? target.current : target);
